import axios from "axios";
import _ from "lodash";
import ConversationModal from '@/components/ConversationModal.vue';

export default {
  name: "ConversationsView",
  components: {
    ConversationModal,
  },
  data() {
    return {
      conversations: [],
      currentPage: 1,
      itemsPerPage: 10,
      totalPages: 0,
      isModalVisible: false,
      selectedConversation: "",
    };
  },
  mounted() {
    this.fetchConversations();
  },
  methods: {
    async fetchConversations() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/call_records`,
          {
            params: {
              skip: (this.currentPage - 1) * this.itemsPerPage,
              limit: this.itemsPerPage,
            },
          }
        );

        this.conversations = response.data.records;
        this.totalPages = Math.ceil(
          response.data.total_count / this.itemsPerPage
        );
      } catch (error) {
        console.error("Error fetching conversations:", error);
        this.totalPages = 1; // Fallback
      }
    },
    onPhoneNumberInput() {
      this.debouncedSearch();
    },
    searchByPhoneNumber() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/call_records`, {
          params: {
            phone_number: this.searchPhoneNumber,
            skip: 0,
            limit: this.itemsPerPage,
          },
        })
        .then((response) => {
          this.conversations = response.data.records;
          this.totalPages = Math.ceil(
            response.data.total_count / this.itemsPerPage
          );
        })
        .catch((error) => {
          console.error("Error searching call records by phone number:", error);
        });
    },
    debouncedSearch: _.debounce(function () {
      this.searchByPhoneNumber();
    }, 300),

    getStatusClass(call_type) {
      return call_type === "completed" ? "status-completed" : "status-default";
    },
    calculateDuration(start, end) {
      const startTime = new Date(start);
      const endTime = new Date(end);
      const duration = Math.floor((endTime - startTime) / 1000);
      return `${duration} сек`;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
        this.fetchConversations();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchConversations();
      }
    },
    openModal(conversation) {
      this.selectedConversation = conversation.call_summary;
      this.isModalVisible = true;
    },
  },
};